import { GoPlus } from "react-icons/go";
import { nodept } from "../../../constant/import";
import { Button } from "../../../components/forms";
import { Link } from "react-router-dom";

export default (props: any) => (
  <div className=" border w-[50%] mt-4 py-10 border-gray-300 rounded-[8px] p-4 flex justify-center items-center flex-col">
    <img src={nodept} />

    <p className="font-bold text-textbg">No Department</p>
    <p className="font-light text-sm my-2  text-center">
      No department has been created in this business/company Click the link
      below to create
    </p>
    <Link className="font-bold text-primary underline text-sm" to="/home/settings/departments">Rwnd engage/Settings/Departments</Link>
  </div>
);
